const axios = require("axios").default;

const URL = `${process.env.REACT_APP_API_URL}`;

export const getUsername = (payload) => {
    return axios.get(`${URL}/username`, {
        params: payload,
    }).catch((error) => {
        if (error.response) {
            return error.response;
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log(error.message);
        }
    });
};
export const getChanges = (payload) => {
    return axios.get(`${URL}/return/changes`, {
        params: payload,
    }).catch((error) => {
        if (error.response) {
            return error.response;
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log(error.message);
        }
    });
};

export const postChanges = (payload) => {
    console.log(payload, "payload")
    return axios.post(`${URL}/return/changes`, payload).catch((error) => {
        if (error.response) {
            return error.response.data;
        } else if (error.request) {
            console.log(error.request);
        } else {
            console.log(error.message);
        }
    });
};